import React from "react";
import { CloseIcon } from "../features/common/icons";

type ModalProps = {
  children: React.ReactNode;
  onClose?: () => void;
  ariaLabel?: string;
};

export const Modal: React.FC<ModalProps> = ({
  children,
  onClose,
  ariaLabel,
}) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel ?? "Modal"}
      onClick={onClose}
    >
      {/* Inner content container */}
      <div
        className="relative w-full max-w-[680px] max-h-[90vh] overflow-y-auto bg-white rounded-lg shadow-lg p-6"
        style={{
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE/Edge
        }}
        onClick={(e) => e.stopPropagation()} // prevent overlay click from closing modal
      >
        {/* Top-right close icon */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 transition-colors"
          aria-label="Close modal"
        >
          <CloseIcon />
        </button>

        {children}
      </div>
    </div>
  );
};
